import { CdkMenuModule } from '@angular/cdk/menu';
import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GlobalModule } from '@app/core/global.module';
import { TableColumnActionComponent } from '@app/modules/table/children/table-column-action/components/table-column-action.component';
import { TableColumnHeaderMenuComponent } from '@app/modules/table/children/table-column-header-menu/components/table-column-header-menu.component';
import { TableHeaderModule } from '@app/modules/table/children/table-header/modules/table-header.module';
import { TableFilterPortalDirective } from '@app/modules/table/directives/table-filter-portal.directive';
import { AppDialogModule } from '@components/dialog/modules/app-dialog.module';
import { InputSearchModule } from '@components/input-search/input-search.module';
import { PanelToolsModule } from '@components/panel-tools/panel-tools.module';
import { FuiSidebarComponent } from '@components/sidebar/sidebar.component';
import { SKELETON_LOADER_TOKEN } from '@constants/diConstant';
import { SKELETON_LOADER_CONFIG } from '@constants/mainConstants';
import { RestrictInputDirective } from '@directives/restrict-input/restrict.input.directive';
import {
    FuiButtonComponent,
    FuiCardComponent,
    FuiCheckboxComponent,
    FuiIconComponent,
    FuiMenuComponent,
    FuiMenuItemComponent,
    FuiTooltipDirective,
    FuiEmptyStateComponent,
} from '@fui/fui-components';
import { PaletteLegendComponent } from '@modules/palettes/children/palette-legend/palette-legend.component';
import { EscapeHtmlPipe } from '@pipes/escape-html/escape-html.pipe';
import { StripHtmlPipe } from '@pipes/strip-html/strip-html.pipe';
import { ResizableModule } from 'angular-resizable-element';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { HighlightModule } from '../../../shared/directives/highlight/highlight.module';
import { SkeletonDirectiveModule } from '../../../shared/directives/skeleton/skeleton-directive.module';
import { DynamicFieldsModule } from '../dynamic-fields/dynamic-fields.module';
import { TableCellsModule } from './children/table-cells/table-cells.module';
import { SettingsTableNameDialogComponent } from './dialogs/settings-table-name/settings.table.name.dialog.component';
import { SettingsTableDialogComponent } from './dialogs/settings-table/settings.table.dialog.component';
import { TableLayerDialogModule } from './dialogs/table-layer-dialog/table-layer-dialog.module';
import { ResizeColumnDirective } from './directives/resize-column.directive';
import { CustomPaginationComponent } from './pagination/custom.pagination.component';
import { TableSkeletonComponent } from './table-skeleton/table-skeleton.component';
import { TableComponent } from './table.component';

@NgModule({
    providers: [{ provide: SKELETON_LOADER_TOKEN, useValue: SKELETON_LOADER_CONFIG }],
    declarations: [
        TableComponent,
        SettingsTableDialogComponent,
        SettingsTableNameDialogComponent,
        ResizeColumnDirective,
        TableSkeletonComponent,
        CustomPaginationComponent,
        TableFilterPortalDirective,
    ],
    imports: [
        CommonModule,
        CdkMenuModule,
        GlobalModule,
        DynamicFieldsModule,
        TableLayerDialogModule,
        NgxSkeletonLoaderModule,
        ResizableModule,
        SkeletonDirectiveModule,
        InputSearchModule,
        HighlightModule,
        AppDialogModule,
        PanelToolsModule,
        OverlayModule,
        RestrictInputDirective,
        TableHeaderModule,
        TableCellsModule,
        EscapeHtmlPipe,
        StripHtmlPipe,
        PaletteLegendComponent,
        FuiButtonComponent,
        FuiCardComponent,
        FuiCheckboxComponent,
        FuiIconComponent,
        FuiMenuComponent,
        FuiMenuItemComponent,
        FuiTooltipDirective,
        TableColumnHeaderMenuComponent,
        TableColumnActionComponent,
        FuiEmptyStateComponent,
        FuiSidebarComponent,
    ],
    exports: [
        TableComponent,
        SettingsTableDialogComponent,
        SettingsTableNameDialogComponent,
        TableSkeletonComponent,
        CustomPaginationComponent,
        TableFilterPortalDirective,
        TableHeaderModule,
    ],
})
export class TableModule {}
